import { __spreadArray } from "tslib";
import React, { useEffect, useState } from 'react';
import { MeetingStatus, useAttendeeStatus, useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useSignalingApi } from '../../signaling-api';
import { JoinErrorType } from '../../signaling-api/signaling-api';
import { useVideoConfig } from '../video-config-provider/video-config-provider';
import { DuplexerConnection } from '../../../utils/duplexer';
var MEETING_LOAD_TIMEOUT = 1000 * 10; // 10 sec
var CLIENT_EVENT_SOFT_MUTE = 'client-soft-mute';
export var SignalManager = function () {
    useSessionErrorDetection();
    var _a = useState([]), attendees = _a[0], setAttendees = _a[1];
    var meetingManager = useMeetingManager();
    var _b = useVideoConfig(), duplexerConfig = _b.duplexerConfig, instance = _b.instance;
    var _c = useSignalingApi(), receiveChatMessage = _c.receiveChatMessage, receiveDeleteChatMessage = _c.receiveDeleteChatMessage, receiveReaction = _c.receiveReaction, receiveParticipant = _c.receiveParticipant, softMute = _c.softMute, onRequestSoftMute = _c.onRequestSoftMute, recorderStopped = _c.recorderStopped;
    useEffect(function () {
        var destructors = [];
        var connection = new DuplexerConnection({
            channel: duplexerConfig,
            instanceUpdater: {
                getInstance: function () {
                    return instance;
                },
            },
        });
        connection.on('server', function (payload) {
            var chatMessageAdded = payload.chatMessageAdded, reactionAdded = payload.reactionAdded, chatMessageDeleted = payload.chatMessageDeleted, recordingEnded = payload.recordingEnded;
            chatMessageAdded && receiveChatMessage(chatMessageAdded);
            reactionAdded && receiveReaction(reactionAdded);
            chatMessageDeleted && receiveDeleteChatMessage(chatMessageDeleted.id);
            if (recordingEnded) {
                recorderStopped(recordingEnded.recording);
            }
        });
        connection.on(CLIENT_EVENT_SOFT_MUTE, function (payload) {
            softMute(payload);
        });
        destructors.push(onRequestSoftMute(function (payload) {
            connection.send(CLIENT_EVENT_SOFT_MUTE, payload);
        }));
        return function () {
            destructors.forEach(function (destructor) { return destructor(); });
            connection.disconnect();
        };
    }, [instance]);
    useEffect(function () {
        // TODO: below messages are not implemented in duplexer as of now
        meetingManager.audioVideo.realtimeSubscribeToAttendeeIdPresence(function (attendeeId, present, participantId, _dropped) {
            // skip secondary attendees, eg #content for screenshare
            if (attendeeId.includes('#')) {
                return;
            }
            receiveParticipant({
                participantId: participantId,
                present: present,
            });
            setAttendees(function (oldAttendees) {
                if (!oldAttendees.find(function (participant) { return participant.attendeeId === attendeeId; })) {
                    return __spreadArray(__spreadArray([], oldAttendees, true), [{ attendeeId: attendeeId, participantId: participantId }], false);
                }
                else {
                    return oldAttendees;
                }
            });
        });
    }, []);
    useEffect(function () {
        var destructors = [];
        return function () {
            destructors.forEach(function (destructor) { return destructor(); });
        };
    }, []);
    return (React.createElement(React.Fragment, null, attendees.map(function (participant) { return (React.createElement(AttendeeManager, { key: participant.participantId, participant: participant })); })));
};
var AttendeeManager = function (_a) {
    var participant = _a.participant;
    var _b = useAttendeeStatus(participant.attendeeId), muted = _b.muted, videoEnabled = _b.videoEnabled, sharingContent = _b.sharingContent;
    var receiveParticipantStatus = useSignalingApi().receiveParticipantStatus;
    useEffect(function () {
        receiveParticipantStatus({
            participantId: participant.participantId,
            muted: muted,
            video: videoEnabled,
            screenshare: sharingContent,
        });
    }, [muted, videoEnabled, sharingContent]);
    return null;
};
var useSessionErrorDetection = function () {
    var meetingManager = useMeetingManager();
    var joinError = useSignalingApi().joinError;
    useEffect(function () {
        var loadingTimeout;
        meetingManager.subscribeToMeetingStatus(function (status) {
            if (!loadingTimeout) {
                if (status === MeetingStatus.Loading) {
                    loadingTimeout = setTimeout(function () { return joinError({ type: JoinErrorType.TIMEOUT }); }, MEETING_LOAD_TIMEOUT);
                }
            }
            else {
                if (status === MeetingStatus.Failed) {
                    joinError({ type: JoinErrorType.FAILED });
                    clearTimeout(loadingTimeout);
                }
                else if (status !== MeetingStatus.Loading) {
                    clearTimeout(loadingTimeout);
                }
            }
        });
    }, []);
};
//# sourceMappingURL=signal-manager.js.map